export const getProp = (obj: any, prop: string) =>
  obj?.[prop] ??
  obj?.[prop.charAt(0).toUpperCase() + prop.slice(1)] ??
  obj?.[prop.charAt(0).toLowerCase() + prop.slice(1)];

export const getApiData = <T>(response: any, operation: string): T => {
  if (!response || typeof response !== 'object') {
    throw new Error(`Invalid API response while ${operation}.`);
  }

  const success = getProp(response, 'success');
  if (success === false) {
    const error = getProp(response, 'error');
    const message = getProp(error, 'message') || getProp(response, 'message');
    throw new Error(message || `Request failed while ${operation}.`);
  }

  const data = getProp(response, 'data');
  if (data === undefined || data === null) {
    throw new Error(`Missing response data while ${operation}.`);
  }

  return data as T;
};

export const getApiCollection = <T>(response: any, operation: string): T[] => {
  if (Array.isArray(response)) {
    return response as T[];
  }

  if (response && typeof response === 'object') {
    const directValue = getProp(response, 'value');
    if (Array.isArray(directValue)) {
      return directValue as T[];
    }

    const success = getProp(response, 'success');
    const directData = getProp(response, 'data');
    if (success === true && (directData === null || directData === undefined)) {
      return [];
    }
  }

  const data = getApiData<any>(response, operation);

  if (Array.isArray(data)) {
    return data as T[];
  }

  if (data === null || data === undefined) {
    return [];
  }

  const value = getProp(data, 'value');

  if (value == null) {
    return [];
  }

  if (!Array.isArray(value)) {
    throw new Error(`Invalid API response while ${operation}: expected a data.value array.`);
  }

  return value as T[];
};
